import { AuthorDotBg, AuthorPic } from "../assets";
import { ButtonLink } from "../components/Button";
import { SubtitleWrapper, TextShadeWrapper } from "../components/Wrappers";
import { AUTHOR_PROFILE_LINK } from "../constants";

const AboutAuthor = () => {
  return (
    <div className="about-author">
      <div className="about-author__banner">
        <img
          className="about-author__banner__bg"
          src={AuthorDotBg}
          alt="dot-bg"
        />
        <img
          className="about-author__banner__profilepic"
          src={AuthorPic}
          alt="profilepic"
        />
      </div>
      <div className="about-author__content">
        <div className="about-author__title">
          About <TextShadeWrapper>the Author</TextShadeWrapper>
        </div>
        <SubtitleWrapper
          fontSize="18px"
          fontSizeSm="22px"
          lineHeight="30px"
          marginTop="21px"
          marginBottom="30px"
          textAlignMd="center"
          textAlignSm="left"
        >
          Monty C. M. Metzger is a German entrepreneur and investor who is known
          for his expertise on the future of digital. He takes an
          anthropological approach, analyzing near-horizon global trends,
          disruptive technologies, and consumer innovations that are on the
          verge of hitting critical mass, and then translates these into usable
          business strategies. Monty has a background in finance and business
          administration, and has over two decades of experience in the tech
          industry. He found his first internet company at 18 and later founded
          a future research firm with offices in multiple countries. After
          selling the company, he has supported tech startups as a business
          angel, investor, and consultant. He is also a founding partner
          emeritus at a venture capital firm and currently serves as the CEO and
          founder of LCX AG, a Liechtenstein-based cryptoassets exchange that is
          innovating capital markets powered by blockchain technology. In this
          role, he is responsible for the overall vision, strategy, and
          direction of the company.
        </SubtitleWrapper>
        {/* <a className="more-info" href="/">
            ..more info
          </a> */}

        <ButtonLink secondaryBtn href={AUTHOR_PROFILE_LINK} widthSm="100%">
          About the Author
        </ButtonLink>
        {/* <div className="about-author__profile">
          <img src={ProfilePic} alt="profile-pic" />
          <div className="about-author__profile__details">
            <div>Andrew Moore</div>
            <div>Entrepreneur, Writer and Speaker</div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default AboutAuthor;
